export default __webpack_public_path__ + "static/media/blackblood.d3abfb9f.png";